import lazyLoading from './lazyLoading'

export default {
  name: 'Utils',
  system: 'utils',
  auth: 'admin',
  meta: {
    auth: true,
    icon: 'fa-wrench',
    expanded: false
  },
  children: [{
    name: 'GSC',
    path: '/reports',
    component: lazyLoading('utils/reports', true),
    meta: {
      label: 'GSC',
      expanded: false
    }
  },
    {
      name: 'Reuploader',
      path: '/reuploader',
      component: lazyLoading('utils/Reuploader'),
      meta: {
        label: 'Reuploder',
        expanded: false
      }
    },
    {
      name: 'DataManager',
      path: '/data_manager',
      component: lazyLoading('utils/DataManager'),
      meta: {
        label: 'Data Manager',
        expanded: false
      }
    },
    {
      name: 'LinkedDomains',
      path: '/linked_domains',
      component: lazyLoading('utils/linkedDomains', true),
      meta: {
        label: 'Linked Domains',
        expanded: false
      }
    },
    {
      name: 'SitesData',
      path: '/sites_data',
      component: lazyLoading('utils/SitesData'),
      meta: {
        label: 'Sites Data',
        expanded: false
      }
    },
    {
      name: 'BonusKeywordsMaker',
      path: '/bonus_keywords_maker',
      component: lazyLoading('utils/BonusKeywordsMaker'),
      meta: {
        label: 'BonusKeywordsMaker',
        expanded: false
      }
    },
    {
      name: 'Ordered Articles',
      path: '/orderedArticles',
      meta: {
        label: 'Ordered Articles',
        expanded: false
      },
      component: lazyLoading('utils/orderedArticles', true)
    }, {
      name: 'Location',
      path: '/location',
      meta: {
        label: 'Location',
        expanded: false
      },
      component: lazyLoading('utils/location', true)
    }, {
      name: 'Domains',
      path: '/domains',
      meta: {
        label: 'Domains',
        expanded: false
      },
      component: lazyLoading('utils/domainsRegister', true)
    },
    {
      name: 'ResearchInspector',
      path: '/research_inspector',
      meta: {
        label: 'ResearchInspector',
        expanded: false
      },
      component: lazyLoading('utils/researchInspector', true)
    },
    {
      name: 'ContentUpgrade',
      path: '/content_upgrade',
      meta: {
        label: 'ContentUpgrade',
        expanded: false
      },
      component: lazyLoading('utils/ContentUpgrade')
    },
    {
      name: 'CTROptimization',
      path: '/ctr_optimization',
      meta: {
        label: 'CTR Optimization',
        expanded: false
      },
      component: lazyLoading('utils/ctrOptimization', true)
    },
    {
      name: 'TitleAndDescriptionMaker',
      path: '/title_and_description_maker',
      meta: {
        label: 'TitleAndDescriptionMaker',
        expanded: false
      },
      component: lazyLoading('utils/metaAndDescriptionMaker', true)
    }, {
      name: 'testDomain',
      path: '/test_domains',
      meta: {
        label: 'TestDomains',
        expanded: false
      },
      component: lazyLoading('utils/TestDomains')
    }
  ]
}
